// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2Ubjo","label":"Completed_label__vVWrH"};